import React from "react"
import cx from "classnames"
import Icon from "./icons"

// Chips or Radio Buttons

export const RadioChip = ({className, children, ...props}) => (
  <button className={cx(className, "chip")} value={children} role="radio" {...props}>
    <div className="flex items-center gap-x-1">{children}</div>
  </button>
)

export const Chip = ({className, children, ...props}) => (
  <div className={cx(className, "chip")} {...props}>
    {children}
  </div>
)

export const CheckChip = ({className, checked, children, ...props}) => (
  <button
    className={cx(className, "chip translate-all", checked && "bg-primary-1 border-primary-1 hover:bg-primary-1 text-neutral-20 flex gap-x-2 items-center pl-3 ")}
    role="checkbox"
    aria-checked={checked ? "true" : "false"}
    {...props}
  >
    {checked && <Icon name="check-mark" className="text-neutral-20" />}
    {children}
  </button>
)

export const Chips = ({className, name, required, children}) => {
  return (
    <div className={cx(className, "flex flex-wrap gap-y-3 gap-x-3")}>
      <input type="hidden" name={name} required={required} />
      {children}
    </div>
  )
}
